module.exports = __webpack_public_path__ + "static/media/logo.dbc6e8e2.png";